import { Animations as CoreAnimations } from '@yanolja-rnd/ya-com-core';

const Animations = {
  ...CoreAnimations,
  // Add your custom animations here
};
export { Animations };
